import React from 'react';
import { useFormContext } from 'react-hook-form';
import UtilityService from '../../../services/UtilityService';
import { UIConstants } from '../../../utils/constants';
import LabeledTextbox from '../../input/LabeledTextbox';
import PadLock from '../../content/PadLock';
import ToolTip from '../../content/ToolTip';
import LabeledDropdown from '../../input/LabeledDropdown';

export const CreditCardTestId = 'CreditCard-methods-payment-input';

export interface CreditCardFormData {
  cardNumber: string;
  cardHolderName: string;
  expMonth: string;
  expYear: string;
  cvv?: string;
}

const CreditCardWithFormContext: React.FC = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<{
    creditCard: {
      cardNumber: string;
      cardHolderName: string;
      expMonth: string;
      expYear: string;
      cvv: string;
    };
  }>();

  return (
    <div data-testid={CreditCardTestId}>
      <div className="flex flex-col">
        <LabeledTextbox
          name="creditCard.cardNumber"
          label="Card Number"
          icon={<PadLock />}
          autoComplete="cc-number"
          type="tel"
          inputMode="numeric"
          pattern="[0-9\s]{13,19}"
          register={register}
          errorLabel={errors?.creditCard?.cardNumber?.message}
        />
      </div>
      <div className="flex flex-col">
        <LabeledTextbox
          name="creditCard.cardHolderName"
          label="Name on Card"
          register={register}
          errorLabel={errors?.creditCard?.cardHolderName?.message}
        />
      </div>
      <div className="flex flex-row w-full justify-between">
        <LabeledDropdown
          className="w-full"
          name="creditCard.expMonth"
          label="Month"
          options={UtilityService.getMonthListAsSelectOptions()}
          register={register}
          errorLabel={errors?.creditCard?.expMonth?.message}
        />
        <LabeledDropdown
          className="w-full"
          name="creditCard.expYear"
          label="Year"
          options={UtilityService.getYearListAsSelectOptions()}
          register={register}
          errorLabel={errors?.creditCard?.expYear?.message}
        />
        <LabeledTextbox
          className="w-full"
          name="creditCard.cvv"
          label="CVV"
          type="password"
          inputMode="numeric"
          pattern="[0-9]{3,4}"
          register={register}
          errorLabel={errors?.creditCard?.cvv?.message}
          maxLength={4}
          icon={
            <ToolTip
              tipText={UIConstants.CVV_TOOL_TIP}
              yPosition="above"
              xPosition="left"
              isInputIcon
            />
          }
        />
      </div>
    </div>
  );
};

export default CreditCardWithFormContext;
